import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { setUser } from '../../store/authSlice';
import API from '../../services/API';
import CONSTANT from '../../utils/constant';

export default function Logout() {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.auth.user);

  const handleLogout = async () => {
    if (localStorage.getItem(CONSTANT.STORAGE_KEY.DRIVER_USER)) {
      try {
        await API.logout();
        dispatch(setUser(null));
      } catch (error) {
        console.log(error);
        localStorage.removeItem(CONSTANT.STORAGE_KEY.DRIVER_USER);
      }
    }
  };

  useEffect(() => {
    if (localStorage.getItem(CONSTANT.STORAGE_KEY.DRIVER_USER)) {
      console.log('Logout', user);
      handleLogout();
    }
  }, [user]);
  return <Navigate to="/login" />;
}
